module.exports = __webpack_public_path__ + "img/article-6.dc516d73.jpg";